import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";

import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Navigate,
  useLocation,
  redirect,
  Outlet
} from "react-router-dom";

import ReactGA from "react-ga4";

import { LoginPage } from "./routes/LoginPage";
import { ResetPassPage } from "./routes/ResetPassPage";
import { NewPassPage } from "./routes/NewPassPage";

import { ForbiddenPage } from "./routes/ForbiddenPage";

import DashboardPaciente from "./routes/DashboardPaciente";

import { PacienteList } from "./routes/PacienteList";

import CalendarList, { loader as CalendarLoader } from "./routes/Calendar";

import PacienteItem, {
  loader as PacienteItemLoader,
} from "./routes/PacienteItem";

import {
  PacienteDatosItem,
  loader as PacienteDatosItemLoader,
} from "./routes/PacienteDatosItem";

import {
  TratamientoItemContent,
  loader as TratamientoItemLoader,
} from "./routes/TratamientoItem";

// Antecedentes
import {
  EntmotivacionalListContent,
  loader as EntmotivacionalListLoader,
} from "./routes/EntmotivacionalList";
import {
  EntmotivacionalItem,
  loader as EntmotivacionalItemLoader,
} from "./routes/EntmotivacionalItem";
import { EntmotivacionalNew } from "./routes/EntmotivacionalNew";
import { EntmotivacionalEdit } from "./routes/EntmotivacionalEdit";

import {
  AntmedicosListContent,
  loader as AntmedicosListLoader,
} from "./routes/AntmedicosList";
import {
  AntmedicosItem,
  loader as AntmedicosItemLoader,
} from "./routes/AntmedicosItem";
import { AntmedicosNew } from "./routes/AntmedicosNew";
import { AntmedicosEdit } from "./routes/AntmedicosEdit";

import {
  AntpsicologicosListContent,
  loader as AntpsicologicosListLoader,
} from "./routes/AntpsicologicosList";
import {
  AntpsicologicosItem,
  loader as AntpsicologicosItemLoader,
} from "./routes/AntpsicologicosItem";
import { AntpsicologicosNew } from "./routes/AntpsicologicosNew";
import { AntpsicologicosEdit } from "./routes/AntpsicologicosEdit";

import {
  ExpmedicaListContent,
  loader as ExpmedicaListLoader,
} from "./routes/ExpmedicaList";
import {
  ExpmedicaItem,
  loader as ExpmedicaItemLoader,
} from "./routes/ExpmedicaItem";
import { ExpmedicaNew } from "./routes/ExpmedicaNew";
import { ExpmedicaEdit } from "./routes/ExpmedicaEdit";

import {
  DatconsumoListContent,
  loader as DatconsumoListLoader,
} from "./routes/DatconsumoList";
import {
  DatconsumoItem,
  loader as DatconsumoItemLoader,
} from "./routes/DatconsumoItem";
import { DatconsumoNew } from "./routes/DatconsumoNew";
import { DatconsumoEdit } from "./routes/DatconsumoEdit";

import {
  ConspretratamientoListContent,
  loader as ConspretratamientoListLoader,
} from "./routes/ConspretratamientoList";
import {
  ConspretratamientoItem,
  loader as ConspretratamientoItemLoader,
} from "./routes/ConspretratamientoItem";
import { ConspretratamientoNew } from "./routes/ConspretratamientoNew";
import { ConspretratamientoEdit } from "./routes/ConspretratamientoEdit";

// Hospitalización
import {
  VismedicasListContent,
  loader as VismedicasListLoader,
} from "./routes/VismedicasList";
import {
  VismedicasItem,
  loader as VismedicasItemLoader,
} from "./routes/VismedicasItem";
import { VismedicasNew } from "./routes/VismedicasNew";
import { VismedicasEdit } from "./routes/VismedicasEdit";

import {
  VispsicologicasListContent,
  loader as VispsicologicasListLoader,
} from "./routes/VispsicologicasList";
import {
  VispsicologicasItem,
  loader as VispsicologicasItemLoader,
} from "./routes/VispsicologicasItem";
import { VispsicologicasNew } from "./routes/VispsicologicasNew";
import { VispsicologicasEdit } from "./routes/VispsicologicasEdit";

// Seguimiento
import {
  PsicoterapiaListContent,
  loader as PsicoterapiaListLoader,
} from "./routes/PsicoterapiaList";
import {
  PsicoterapiaItem,
  loader as PsicoterapiaItemLoader,
} from "./routes/PsicoterapiaItem";
import { PsicoterapiaNew } from "./routes/PsicoterapiaNew";
import { PsicoterapiaEdit } from "./routes/PsicoterapiaEdit";

import {
  NutricionListContent,
  loader as NutricionListLoader,
} from "./routes/NutricionList";
import {
  NutricionItem,
  loader as NutricionItemLoader,
} from "./routes/NutricionItem";
import { NutricionNew } from "./routes/NutricionNew";
import { NutricionEdit } from "./routes/NutricionEdit";

import {
  MindfulnessListContent,
  loader as MindfulnessListLoader,
} from "./routes/MindfulnessList";
import {
  MindfulnessItem,
  loader as MindfulnessItemLoader,
} from "./routes/MindfulnessItem";
import { MindfulnessNew } from "./routes/MindfulnessNew";
import { MindfulnessEdit } from "./routes/MindfulnessEdit";

import {
  EntrenamientoListContent,
  loader as EntrenamientoListLoader,
} from "./routes/EntrenamientoList";
import {
  EntrenamientoItem,
  loader as EntrenamientoItemLoader,
} from "./routes/EntrenamientoItem";
import { EntrenamientoNew } from "./routes/EntrenamientoNew";
import { EntrenamientoEdit } from "./routes/EntrenamientoEdit";

import {
  ConspostratamientoListContent,
  loader as ConspostratamientoListLoader,
} from "./routes/ConspostratamientoList";
import {
  ConspostratamientoItem,
  loader as ConspostratamientoItemLoader,
} from "./routes/ConspostratamientoItem";
import { ConspostratamientoNew } from "./routes/ConspostratamientoNew";
import { ConspostratamientoEdit } from "./routes/ConspostratamientoEdit";

// Interconsultas
import {
  InterconsultaListContent,
  loader as InterconsultaListLoader,
} from "./routes/InterconsultaList";
import {
  InterconsultaItem,
  loader as InterconsultaItemLoader,
} from "./routes/InterconsultaItem";
import {
  InterconsultaNew,
  loader as InterconsultaNewLoader,
} from "./routes/InterconsultaNew";
import { InterconsultaEdit } from "./routes/InterconsultaEdit";

// Cuestionarios
import {
  Scl90ListContent,
  loader as Scl90ListLoader,
} from "./routes/Scl90List";
import { Scl90Item, loader as Scl90ItemLoader } from "./routes/Scl90Item";
import { Scl90New } from "./routes/Scl90New";
import { Scl90Edit } from "./routes/Scl90Edit";
import { Scl90PacienteEdit } from "./routes/Scl90PacienteEdit";
import {
  Scl90PacienteItem,
  loader as Scl90PacienteItemLoader,
} from "./routes/Scl90PacienteItem";
import {
  Scl90ComparativaItem,
  loader as Scl90ComparativaItemLoader,
} from "./routes/Scl90ComparativaItem";

import { IsiListContent, loader as IsiListLoader } from "./routes/IsiList";
import { IsiItem, loader as IsiItemLoader } from "./routes/IsiItem";
import { IsiNew } from "./routes/IsiNew";
import { IsiEdit } from "./routes/IsiEdit";

import { PsqiListContent, loader as PsqiListLoader } from "./routes/PsqiList";
import { PsqiItem, loader as PsqiItemLoader } from "./routes/PsqiItem";
import { PsqiNew } from "./routes/PsqiNew";
import { PsqiEdit } from "./routes/PsqiEdit";
import { PsqiPacienteEdit } from "./routes/PsqiPacienteEdit";
import {
  PsqiPacienteItem,
  loader as PsqiPacienteItemLoader,
} from "./routes/PsqiPacienteItem";
import {
  PsqiComparativaItem,
  loader as PsqiComparativaItemLoader,
} from "./routes/PsqiComparativaItem";

import {
  AuditListContent,
  loader as AuditListLoader,
} from "./routes/AuditList";
import { AuditItem, loader as AuditItemLoader } from "./routes/AuditItem";
import { AuditNew } from "./routes/AuditNew";
import { AuditEdit } from "./routes/AuditEdit";

import { Who5ListContent, loader as Who5ListLoader } from "./routes/Who5List";
import { Who5Item, loader as Who5ItemLoader } from "./routes/Who5Item";
import {
  Who5PacienteItem,
  loader as Who5PacienteItemLoader,
} from "./routes/Who5PacienteItem";
import {
  Who5ComparativaItem,
  loader as Who5ComparativaItemLoader,
} from "./routes/Who5ComparativaItem";
import { Who5PacienteEdit } from "./routes/Who5PacienteEdit";
import { Who5New } from "./routes/Who5New";
import { Who5Edit } from "./routes/Who5Edit";

// Analiticas
import {
  AnaliticasListContent,
  loader as AnaliticasListLoader,
} from "./routes/AnaliticasList";
import {
  AnaliticasItem,
  loader as AnaliticasItemLoader,
} from "./routes/AnaliticasItem";
import { AnaliticasNew } from "./routes/AnaliticasNew";
import { AnaliticasEdit } from "./routes/AnaliticasEdit";
import {
  AnaliticasComparativaItem,
  loader as AnaliticasComparativaItemLoader,
} from "./routes/AnaliticasComparativaItem";

import {
  AnaliticasPacienteItem,
  loader as AnaliticasPacienteItemLoader,
} from "./routes/AnaliticasPacienteItem";

import MejorateIntro, {
  loader as MejorateIntroLoader,
} from "./routes/MejorateIntro";
import MejorateList, {
  loader as MejorateListLoader,
} from "./routes/MejorateList";
import MejorateAlcohol, {
  loader as MejorateAlcoholLoader,
} from "./routes/MejorateAlcohol";
import MejorateCocaina, {
  loader as MejorateCocainaLoader,
} from "./routes/MejorateCocaina";
import MejorateBenzodiazepina, {
  loader as MejorateBenzodiazepinaLoader,
} from "./routes/MejorateBenzodiazepina";
import MejorateCannabis, {
  loader as MejorateCannabisLoader,
} from "./routes/MejorateCannabis";

// Documentacion
import {
  DocumentacionListContent,
  loader as DocumentacionListLoader,
} from "./routes/DocumentacionList";
import {
  DocumentacionItem,
  loader as DocumentacionItemLoader,
} from "./routes/DocumentacionItem";
import { DocumentacionNew } from "./routes/DocumentacionNew";
import { DocumentacionEdit } from "./routes/DocumentacionEdit";

// Citas
import { CitaList, loader as CitaListLoader } from "./routes/CitaList";
import { CitaItem, loader as CitaItemLoader } from "./routes/CitaItem";
import { CitaNew } from "./routes/CitaNew";
import { CitaEdit } from "./routes/CitaEdit";

import "./index.css";
import "./index-router.css";
import "./bulma.css";

import {
  ConfiguracionContent,
  loader as ConfiguracionLoader,
} from "./components/Configuracion";

import {
  TratamientoAdminList,
  loader as TratamientoAdminListLoader,
} from "./components/TratamientoAdminList";
import {
  TratamientoAdminItem,
  loader as TratamientoAdminItemLoader,
} from "./components/TratamientoAdminItem";
import { TratamientoAdminNew } from "./components/TratamientoAdminNew";
import { TratamientoAdminEdit } from "./components/TratamientoAdminEdit";

import { PacienteAdminList } from "./components/PacienteAdminList";
import {
  PacienteAdminItem,
  loader as PacienteAdminItemLoader,
} from "./components/PacienteAdminItem";
import { PacienteAdminNew } from "./components/PacienteAdminNew";
import { PacienteAdminEdit } from "./components/PacienteAdminEdit";

import {
  EspecialistaAdminList,
  loader as EspecialistaAdminListLoader,
} from "./components/EspecialistaAdminList";
import {
  EspecialistaAdminItem,
  loader as EspecialistaAdminItemLoader,
} from "./components/EspecialistaAdminItem";
import { EspecialistaAdminNew } from "./components/EspecialistaAdminNew";
import { EspecialistaAdminEdit } from "./components/EspecialistaAdminEdit";

import {
  ListadoAdminList,
  loader as ListadoAdminListLoader,
} from "./components/ListadoAdminList";
import {
  ListadoAdminItem,
  loader as ListadoAdminItemLoader,
} from "./components/ListadoAdminItem";
import {
  ListadoAdminTratamientos,
  loader as ListadoAdminTratamientosLoader,
} from "./components/ListadoAdminTratamientos";
import { ListadoAdminPacientes } from "./components/ListadoAdminPacientes";
// import { TratamientoAdminItem, loader as TratamientoAdminItemLoader } from "./components/TratamientoAdminItem";
// import { TratamientoAdminNew } from "./components/TratamientoAdminNew";
// import { TratamientoAdminEdit } from "./components/TratamientoAdminEdit";

import {
  NotificacionesList,
  NotificacionesPaciente,
} from "./routes/Notificaciones";

import { Sueno } from "./routes/Sueno";

import { Creditos } from "./routes/Creditos";

import {
  CuestPsicoterapia
} from "./routes/CuestPsicoterapia";

import ErrorPage from "./components/ErrorPage";

import * as APIUSER from "./services/user";

// Define el RootLayout inline
const RootLayout = () => <Outlet />;

// Verifica si el dominio es de producción antes de inicializar Google Analytics
const isProduction = window.location.hostname === "app.tavad.com";

if (isProduction) {
  ReactGA.initialize("G-B4GDV62C1M");
}

// Componente que maneja Google Analytics
const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (isProduction) {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location]);

  return null;
};

const App = () => {
  const [userRole, setUserRole] = useState(["paciente"]); // Rol por defecto
  const [currentUser, setCurrentUser] = useState(null); // Almacena el usuario actual
  const [especialistaFullName, setEspecialistaFullName] = useState("");
  const [especialistaId, setEspecialistaId] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Estado de carga

  const especialistaRoles = [
    "administrador",
    "medicina",
    "psicologia",
    "psicologia-hospital",
    "nutricion",
    "entrenamiento",
    "mindfulness",
    "especialista",
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // 1) Comprobamos si hay token antes de llamar a la API:
        const token = sessionStorage.getItem("token");
        if (!token) {
          // No hay token → no llamamos a getCurrentUser y marcamos isLoading = false
          setIsLoading(false);
          return; 
        }
  
        // 2) Si sí hay token, ahora sí llamamos a la API
        const currentUserData = await APIUSER.getCurrentUser();
        if (currentUserData) {
          setEspecialistaFullName(
            `${currentUserData?.first_name} ${currentUserData?.last_name}`
          );
          setEspecialistaId(currentUserData?.id);
          setCurrentUser(currentUserData);
          setIsAuthenticated(true); // o !!token, como prefieras
  
          const arrayRoles = currentUserData?.role || [];
          const userEspecialidad = currentUserData?.meta?.especialidad;
  
          if (arrayRoles.includes("administrator")) {
            setUserRole(["administrador"]);
          } else if (arrayRoles.includes("author")) {
            if (Array.isArray(userEspecialidad)) {
              setUserRole(
                userEspecialidad.map((especialidad) => especialidad.value)
              );
            }
          } else {
            setUserRole(["paciente"]);
          }
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchUserData();
  }, []);
  

  if (isLoading) {
    return (
      // Muestra algo mientras se cargan los datos del usuario
      <div className="loader-container">
        <span className="loader"></span>
      </div>
    );
  }

  // 3) Definimos un loader para la ruta padre privada:
  //    Básicamente, si NO hay token, redirigimos a login.
  const authLoader = async () => {
    // Ojo: aquí no puedes usar "isAuthenticated" directamente
    // porque es un estado de React y los loaders se ejecutan antes.
    // Lo más simple es verificar "sessionStorage.getItem('token')".
    const token = sessionStorage.getItem("token");
    if (!token) {
      throw redirect(
        `/login?redirect_to=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`
      );
    }
    // Podrías hacer verificación de roles aquí también, si quieres
    // (Por ejemplo, si userRole no incluye algún valor, redirect a /perfil)
    return null; 
  };

  // Crear el enrutador después de obtener los datos del usuario

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          // Ruta inicial → decide adónde ir según si está logueado o no
          index: true,
          element: isAuthenticated ? (
            userRole.some((role) => especialistaRoles.includes(role)) ? (
              <Navigate to="/pacientes" />
            ) : (
              <Navigate to="/perfil" />
            )
          ) : (
            <Navigate
              to={`/login?redirect_to=${encodeURIComponent(
                window.location.pathname + window.location.search
              )}`}
            />
          ),
        },
        // Rutas públicas
        {
          path: "login",
          element: <LoginPage />,
        },
        {
          path: "reset-password",
          element: <ResetPassPage />,
        },
        {
          path: "new-password",
          element: <NewPassPage />,
        },
        {
          path: "sin-permisos",
          element: <ForbiddenPage />,
        },
        {
          path: "cuestionario-psicoterapia",
          element: <CuestPsicoterapia />,
        },

        // ******* PADRE PRIVADO *******
        {
          // Este padre no agrega nada a la URL (path: "")
          // pero todo lo que cuelgue dentro se protege con su "loader"
          path: "",
          loader: authLoader,   // Chequea token y, si no hay, redirige a login
          element: <Outlet />,  // Contenedor de rutas privadas
          children: [
            {
              path: "pacientes",
              element: isAuthenticated ? (
                userRole.some((role) => especialistaRoles.includes(role)) ? (
                  <PacienteList
                    especialistaFullName={especialistaFullName}
                    especialistaId={especialistaId}
                    userRole={userRole}
                  />
                ) : (
                  <Navigate to="/perfil" />
                )
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
            },
            {
              path: "pacientes/:pacienteId",
              element: isAuthenticated ? (
                userRole.some((role) => especialistaRoles.includes(role)) ? (
                  <PacienteItem especialistaId={especialistaId} userRole={userRole} />
                ) : (
                  <Navigate to="/perfil" />
                )
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
              loader: PacienteItemLoader,
              children: [
                {
                  path: "datos",
                  element: isAuthenticated ? (
                    <PacienteDatosItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PacienteDatosItemLoader,
                },
                {
                  path: ":tratamientoId",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/entrevista-motivacional",
                  element: isAuthenticated ? (
                    <EntmotivacionalListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntmotivacionalListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/entrevista-motivacional/new",
                  element: isAuthenticated ? (
                    <EntmotivacionalNew
                      especialistaFullName={especialistaFullName}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntmotivacionalListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/entrevista-motivacional/:entmotivacionalId",
                  element: isAuthenticated ? (
                    <EntmotivacionalItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntmotivacionalItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/entrevista-motivacional/:entmotivacionalId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <EntmotivacionalEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntmotivacionalItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/medicos",
                  element: isAuthenticated ? (
                    <AntmedicosListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntmedicosListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/medicos/new",
                  element: isAuthenticated ? (
                    <AntmedicosNew
                      especialistaFullName={especialistaFullName}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntmedicosListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/medicos/:antmedicosId",
                  element: isAuthenticated ? (
                    <AntmedicosItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntmedicosItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/medicos/:antmedicosId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ? (
                      <AntmedicosEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntmedicosItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/psicologicos",
                  element: isAuthenticated ? (
                    <AntpsicologicosListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntpsicologicosListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/psicologicos/new",
                  element: isAuthenticated ? (
                    <AntpsicologicosNew
                      especialistaFullName={especialistaFullName}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntpsicologicosListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/psicologicos/:antpsicologicosId",
                  element: isAuthenticated ? (
                    <AntpsicologicosItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntpsicologicosItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/psicologicos/:antpsicologicosId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <AntpsicologicosEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AntpsicologicosItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/exploracion-medica",
                  element: isAuthenticated ? (
                    <ExpmedicaListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ExpmedicaListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/exploracion-medica/new",
                  element: isAuthenticated ? (
                    <ExpmedicaNew
                      especialistaFullName={especialistaFullName}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ExpmedicaListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/exploracion-medica/:expmedicaId",
                  element: isAuthenticated ? (
                    <ExpmedicaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ExpmedicaItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/exploracion-medica/:expmedicaId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ? (
                      <ExpmedicaEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ExpmedicaItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/datos-consumo",
                  element: isAuthenticated ? (
                    <DatconsumoListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DatconsumoListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/datos-consumo/new",
                  element: isAuthenticated ? (
                    <DatconsumoNew
                      especialistaFullName={especialistaFullName}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DatconsumoListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/datos-consumo/:datconsumoId",
                  element: isAuthenticated ? (
                    <DatconsumoItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DatconsumoItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/datos-consumo/:datconsumoId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <DatconsumoEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DatconsumoItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/consulta-pre-tratamiento",
                  element: isAuthenticated ? (
                    <ConspretratamientoListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspretratamientoListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/consulta-pre-tratamiento/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <ConspretratamientoNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspretratamientoListLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/consulta-pre-tratamiento/:consultapretratamientoId",
                  element: isAuthenticated ? (
                    <ConspretratamientoItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspretratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/antecedentes/consulta-pre-tratamiento/:consultapretratamientoId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <ConspretratamientoEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspretratamientoItemLoader,
                },
        
                //Hospitalizacion
                {
                  path: ":tratamientoId/hospitalizacion",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-medicas",
                  element: isAuthenticated ? (
                    <VismedicasListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VismedicasListLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-medicas/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ? (
                      <VismedicasNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VismedicasListLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-medicas/:vismedicasId",
                  element: isAuthenticated ? (
                    <VismedicasItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VismedicasItemLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-medicas/:vismedicasId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ? (
                      <VismedicasEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VismedicasItemLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-psicologicas",
                  element: isAuthenticated ? (
                    <VispsicologicasListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VismedicasListLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-psicologicas/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <VispsicologicasNew
                        especialistaId={especialistaId}
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VispsicologicasListLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-psicologicas/:vispsicologicasId",
                  element: isAuthenticated ? (
                    <VispsicologicasItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VispsicologicasItemLoader,
                },
                {
                  path: ":tratamientoId/hospitalizacion/visitas-psicologicas/:vispsicologicasId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ||
                    userRole.includes("psicologia") ? (
                      <VispsicologicasEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: VispsicologicasItemLoader,
                },
        
                // Seguimiento
                {
                  path: ":tratamientoId/seguimiento",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/psicoterapia",
                  element: isAuthenticated ? (
                    <PsicoterapiaListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsicoterapiaListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/psicoterapia/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia") ? (
                      <PsicoterapiaNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsicoterapiaListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/psicoterapia/:psicoterapiaId",
                  element: isAuthenticated ? (
                    <PsicoterapiaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsicoterapiaItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/psicoterapia/:psicoterapiaId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia") ? (
                      <PsicoterapiaEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsicoterapiaItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/nutricion",
                  element: isAuthenticated ? (
                    <NutricionListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: NutricionListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/nutricion/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("nutricion") ? (
                      <NutricionNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: NutricionListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/nutricion/:nutricionId",
                  element: isAuthenticated ? (
                    <NutricionItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: NutricionItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/nutricion/:nutricionId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("nutricion") ? (
                      <NutricionEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: NutricionItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/mindfulness",
                  element: isAuthenticated ? (
                    <MindfulnessListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: MindfulnessListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/mindfulness/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("mindfulness") ? (
                      <MindfulnessNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: MindfulnessListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/mindfulness/:mindfulnessId",
                  element: isAuthenticated ? (
                    <MindfulnessItem userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: MindfulnessItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/mindfulness/:mindfulnessId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("mindfulness") ? (
                      <MindfulnessEdit userRole={userRole} />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: MindfulnessItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/entrenamiento",
                  element: isAuthenticated ? (
                    <EntrenamientoListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntrenamientoListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/entrenamiento/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("entrenamiento") ? (
                      <EntrenamientoNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntrenamientoListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/entrenamiento/:entrenamientoId",
                  element: isAuthenticated ? (
                    <EntrenamientoItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntrenamientoItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/entrenamiento/:entrenamientoId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("entrenamiento") ? (
                      <EntrenamientoEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EntrenamientoItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/consulta-post-tratamiento",
                  element: isAuthenticated ? (
                    <ConspostratamientoListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspostratamientoListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/consulta-post-tratamiento/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ||
                    userRole.includes("psicologia") ||
                    userRole.includes("psicologia-hospital") ? (
                      <ConspostratamientoNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspostratamientoListLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/consulta-post-tratamiento/:consultapostratamientoId",
                  element: isAuthenticated ? (
                    <ConspostratamientoItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspostratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/seguimiento/consulta-post-tratamiento/:consultapostratamientoId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("medicina") ||
                    userRole.includes("psicologia") ||
                    userRole.includes("psicologia-hospital") ? (
                      <ConspostratamientoEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: ConspostratamientoItemLoader,
                },
        
                // Interconsultas
                {
                  path: ":tratamientoId/interconsultas",
                  element: isAuthenticated ? (
                    <InterconsultaListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: InterconsultaListLoader,
                },
                {
                  path: ":tratamientoId/interconsultas/new",
                  element: isAuthenticated ? (
                    <InterconsultaNew
                      especialistaId={especialistaId}
                      especialistaFullName={especialistaFullName}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: InterconsultaNewLoader,
                },
                {
                  path: ":tratamientoId/interconsultas/:interconsultaId",
                  element: isAuthenticated ? (
                    <InterconsultaItem
                      especialistaFullName={especialistaFullName}
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: InterconsultaItemLoader,
                },
                {
                  path: ":tratamientoId/interconsultas/:interconsultaId/edit",
                  element: isAuthenticated ? (
                    <InterconsultaEdit
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: InterconsultaItemLoader,
                },
        
                //Cuestionarios
                {
                  path: ":tratamientoId/cuestionarios",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                // Seguimiento
                // {
                //   path: ":tratamientoId/cuestionarios",
                //   element: (isAuthenticated ? <TratamientoItemContent especialistaId={especialistaId} userRole={userRole} />  : <Navigate to="/login" />),
                //   loader: TratamientoItemLoader,
                // },
                // SCL-90
                {
                  path: ":tratamientoId/cuestionarios/scl-90",
                  element: isAuthenticated ? (
                    <Scl90ComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ComparativaItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <Scl90New
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90/:scl90Id",
                  element: isAuthenticated ? (
                    <Scl90Item especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90/:scl90Id/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <Scl90Edit especialistaId={especialistaId} userRole={userRole} />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ItemLoader,
                },
                // ISI
                // {
                //   path: ":tratamientoId/cuestionarios/isi",
                //   element: isAuthenticated ? (
                //     <IsiListContent
                //       especialistaId={especialistaId}
                //       userRole={userRole}
                //     />
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: IsiListLoader,
                // },
                // {
                //   path: ":tratamientoId/cuestionarios/isi/new",
                //   element: isAuthenticated ? (
                //     userRole.includes("administrador") ||
                //     userRole.includes("psicologia-hospital") ? (
                //       <IsiNew
                //         especialistaFullName={especialistaFullName}
                //         userRole={userRole}
                //       />
                //     ) : (
                //       <Navigate to='/sin-permisos' />
                //     )
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: IsiListLoader,
                // },
                // {
                //   path: ":tratamientoId/cuestionarios/isi/:isiId",
                //   element: isAuthenticated ? (
                //     <IsiItem especialistaId={especialistaId} userRole={userRole} />
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: IsiItemLoader,
                // },
                // {
                //   path: ":tratamientoId/cuestionarios/isi/:isiId/edit",
                //   element: isAuthenticated ? (
                //     userRole.includes("administrador") ||
                //     userRole.includes("psicologia-hospital") ? (
                //       <IsiEdit especialistaId={especialistaId} userRole={userRole} />
                //     ) : (
                //       <Navigate to='/sin-permisos' />
                //     )
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: IsiItemLoader,
                // },
                // PSQI
                {
                  path: ":tratamientoId/cuestionarios/psqi",
                  element: isAuthenticated ? (
                    <PsqiComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiComparativaItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/psqi/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <PsqiNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/psqi/:psqiId",
                  element: isAuthenticated ? (
                    <PsqiItem especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/psqi/:psqiId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <PsqiEdit especialistaId={especialistaId} userRole={userRole} />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiItemLoader,
                },
                // AUDIT
                {
                  path: ":tratamientoId/cuestionarios/audit",
                  element: isAuthenticated ? (
                    <AuditListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AuditListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/audit/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <AuditNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AuditListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/audit/:auditId",
                  element: isAuthenticated ? (
                    <AuditItem especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AuditItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/audit/:auditId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <AuditEdit especialistaId={especialistaId} userRole={userRole} />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AuditItemLoader,
                },
                // WHO-5
                {
                  path: ":tratamientoId/cuestionarios/who5",
                  element: isAuthenticated ? (
                    <Who5ComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ComparativaItemLoader,
                },
                // {
                //   path: ":tratamientoId/cuestionarios/who5",
                //   element: isAuthenticated ? (
                //     <Who5ListContent
                //       especialistaId={especialistaId}
                //       userRole={userRole}
                //     />
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: Who5ListLoader,
                // },
                {
                  path: ":tratamientoId/cuestionarios/who5/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <Who5New
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/who5/:who5Id",
                  element: isAuthenticated ? (
                    <Who5Item especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/who5/:who5Id/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("psicologia-hospital") ? (
                      <Who5Edit especialistaId={especialistaId} userRole={userRole} />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ItemLoader,
                },
        
                // Analiticas
                {
                  path: ":tratamientoId/analiticas",
                  element: isAuthenticated ? (
                    <AnaliticasListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasListLoader,
                },
                {
                  path: ":tratamientoId/analiticas/new",
                  element: isAuthenticated ? (
                    <AnaliticasNew currentUser={currentUser} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasListLoader,
                },
                {
                  path: ":tratamientoId/analiticas/:analiticasId",
                  element: isAuthenticated ? (
                    <AnaliticasItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasItemLoader,
                },
                {
                  path: ":tratamientoId/analiticas/:analiticasId/edit",
                  element: isAuthenticated ? (
                    <AnaliticasEdit
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasItemLoader,
                },

                
        
                // Documentacion
                {
                  path: ":tratamientoId/documentacion",
                  element: isAuthenticated ? (
                    <DocumentacionListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DocumentacionListLoader,
                },
                {
                  path: ":tratamientoId/documentacion/new",
                  element: isAuthenticated ? (
                    <DocumentacionNew currentUser={currentUser} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DocumentacionListLoader,
                },
                {
                  path: ":tratamientoId/documentacion/:documentacionId",
                  element: isAuthenticated ? (
                    <DocumentacionItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DocumentacionItemLoader,
                },
                {
                  path: ":tratamientoId/documentacion/:documentacionId/edit",
                  element: isAuthenticated ? (
                    <DocumentacionEdit
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: DocumentacionItemLoader,
                },
              ],
            },
            // Calendario
            {
              path: "calendario",
              element: isAuthenticated ? (
                userRole.some((role) => especialistaRoles.includes(role)) ? (
                  <CalendarList especialistaId={especialistaId} userRole={userRole} />
                ) : (
                  <Navigate to="../sin-permisos" />
                )
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
              //loader: CalendarLoader(especialistaId),
              //loader: CalendarLoader,
              loader: ({ params }) => {
                return CalendarLoader(especialistaId, userRole);
              },
            },
            {
              path: "calendario/cita",
              element: isAuthenticated ? (
                userRole.some((role) => especialistaRoles.includes(role)) ? (
                  <CitaList
                    especialistaId={especialistaId}
                    userRole={userRole}
                    especialistaFullName={especialistaFullName}
                  />
                ) : (
                  <Navigate to="../sin-permisos" />
                )
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
              loader: CitaListLoader,
              children: [
                {
                  path: "new",
                  element: isAuthenticated ? (
                    <CitaNew
                      especialistaId={especialistaId}
                      userRole={userRole}
                      especialistaFullName={especialistaFullName}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
                {
                  path: ":citaId",
                  element: isAuthenticated ? (
                    <CitaItem especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: CitaItemLoader,
                },
                {
                  path: ":citaId/edit",
                  element: isAuthenticated ? (
                    <CitaEdit especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: CitaItemLoader,
                },
              ],
            },
            // Configuración
            {
              path: "configuracion",
              element: isAuthenticated ? (
                userRole.includes("administrador") ? (
                  <ConfiguracionContent
                    especialistaId={especialistaId}
                    userRole={userRole}
                  />
                ) : (
                  <Navigate to="../sin-permisos" />
                )
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
              //loader: ConfiguracionLoader,
              children: [
                // {
                //   path: "tratamientos",
                //   element: (isAuthenticated ? <TratamientoAdminListContent especialistaId={especialistaId} userRole={userRole} />  : <Navigate to="/login" />),
                //   //loader: TratamientoAdminListLoader,
                // },
        
                {
                  path: "pacientes",
                  element: isAuthenticated ? (
                    <PacienteAdminList
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
                {
                  path: "pacientes/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <PacienteAdminNew especialistaFullName={especialistaFullName} />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
                {
                  path: "pacientes/:pacienteId",
                  element: isAuthenticated ? (
                    <PacienteAdminItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PacienteAdminItemLoader,
                },
                {
                  path: "pacientes/:pacienteId/tratamientos/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <TratamientoAdminNew
                        especialistaFullName={especialistaFullName}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PacienteAdminItemLoader,
                },
                {
                  path: "pacientes/:pacienteId/tratamientos/:tratamientoId",
                  element: isAuthenticated ? (
                    <TratamientoAdminItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoAdminItemLoader,
                },
                {
                  path: "pacientes/:pacienteId/tratamientos/:tratamientoId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <TratamientoAdminEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoAdminItemLoader,
                },
                {
                  path: "pacientes/:pacienteId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <PacienteAdminEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PacienteAdminItemLoader,
                },
                {
                  path: "especialistas",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <EspecialistaAdminList />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EspecialistaAdminListLoader,
                },
                {
                  path: "especialistas/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <EspecialistaAdminNew
                        especialistaFullName={especialistaFullName}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EspecialistaAdminListLoader,
                },
                {
                  path: "especialistas/:especialistaId",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <EspecialistaAdminItem
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EspecialistaAdminItemLoader,
                },
                {
                  path: "especialistas/:especialistaId/edit",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <EspecialistaAdminEdit
                        especialistaId={especialistaId}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: EspecialistaAdminItemLoader,
                },
                {
                  path: "listados",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <ListadoAdminList />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  //loader: ListadoAdminListLoader,
                },
                {
                  path: "listado-completo",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <ListadoAdminItem />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  //loader: ListadoAdminItemLoader,
                },
                {
                  path: "listado-tratamientos",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <ListadoAdminTratamientos />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  //loader: ListadoAdminItemLoader,
                },
                {
                  path: "listado-pacientes",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ? (
                      <ListadoAdminPacientes />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
              ],
            },
            // Notificaciones
            {
              path: "notificaciones",
              element: isAuthenticated ? (
                userRole.some((role) => especialistaRoles.includes(role)) ? (
                  <NotificacionesList
                    especialistaId={especialistaId}
                    userRole={userRole}
                  />
                ) : (
                  <Navigate to="../sin-permisos" />
                )
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
            },
            {
              path: "perfil",
              element: isAuthenticated ? (
                <DashboardPaciente
                  especialistaId={especialistaId}
                  userRole={userRole}
                  currentUser={currentUser}
                />
              ) : (
                <Navigate
                  to={`/login?redirect_to=${encodeURIComponent(
                    window.location.pathname + window.location.search
                  )}`}
                />
              ),
              children: [
                // Notificaciones Paciente
                {
                  path: "notificaciones",
                  element: isAuthenticated ? (
                    <NotificacionesPaciente
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
                {
                  path: ":tratamientoId",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                // Cuestionarios
                {
                  path: ":tratamientoId/cuestionarios",
                  element: isAuthenticated ? (
                    <TratamientoItemContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: TratamientoItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90",
                  element: isAuthenticated ? (
                    <Scl90ComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ComparativaItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("paciente") ? (
                      <Scl90New
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90/:scl90Id",
                  element: isAuthenticated ? (
                    <Scl90PacienteItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90PacienteItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/scl-90/:scl90Id/edit",
                  element: isAuthenticated ? (
                    <Scl90PacienteEdit
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Scl90ItemLoader,
                },
                // ISI
                {
                  path: ":tratamientoId/cuestionarios/isi",
                  element: isAuthenticated ? (
                    <IsiListContent
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: IsiListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/isi/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("paciente") ? (
                      <IsiNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: IsiListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/isi/:isiId",
                  element: isAuthenticated ? (
                    <IsiItem especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: IsiItemLoader,
                },
                // PSQI
                {
                  path: ":tratamientoId/cuestionarios/psqi",
                  element: isAuthenticated ? (
                    <PsqiComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiComparativaItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/psqi/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("paciente") ? (
                      <PsqiNew
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/psqi/:psqiId",
                  element: isAuthenticated ? (
                    <PsqiPacienteItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiPacienteItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/psqi/:psqiId/edit",
                  element: isAuthenticated ? (
                    <PsqiPacienteEdit
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: PsqiItemLoader,
                },
                // AUDIT
                // {
                //   path: ":tratamientoId/cuestionarios/audit",
                //   element: isAuthenticated ? (
                //     <AuditListContent
                //       especialistaId={especialistaId}
                //       userRole={userRole}
                //     />
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: AuditListLoader,
                // },
                // {
                //   path: ":tratamientoId/cuestionarios/audit/new",
                //   element: isAuthenticated ? (
                //     userRole.includes("administrador") ||
                //     userRole.includes("paciente") ? (
                //       <AuditNew
                //         especialistaFullName={especialistaFullName}
                //         userRole={userRole}
                //       />
                //     ) : (
                //       <Navigate to='/sin-permisos' />
                //     )
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: AuditListLoader,
                // },
                // {
                //   path: ":tratamientoId/cuestionarios/audit/:auditId",
                //   element: isAuthenticated ? (
                //     <AuditItem especialistaId={especialistaId} userRole={userRole} />
                //   ) : (
                //     <Navigate to={`/login?redirect_to=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
                //   ),
                //   loader: AuditItemLoader,
                // },
                // WHO-5
                {
                  path: ":tratamientoId/cuestionarios/who5",
                  element: isAuthenticated ? (
                    <Who5ComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ComparativaItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/who5/new",
                  element: isAuthenticated ? (
                    userRole.includes("administrador") ||
                    userRole.includes("paciente") ? (
                      <Who5New
                        especialistaFullName={especialistaFullName}
                        userRole={userRole}
                      />
                    ) : (
                      <Navigate to="/sin-permisos" />
                    )
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ListLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/who5/:who5Id",
                  element: isAuthenticated ? (
                    <Who5PacienteItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5PacienteItemLoader,
                },
                {
                  path: ":tratamientoId/cuestionarios/who5/:who5Id/edit",
                  element: isAuthenticated ? (
                    <Who5PacienteEdit
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: Who5ItemLoader,
                },
                {
                  path: ":tratamientoId/analiticas",
                  element: isAuthenticated ? (
                    <AnaliticasComparativaItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasComparativaItemLoader,
                },
                // Analiticas
                {
                  path: ":tratamientoId/analiticas/new",
                  element: isAuthenticated ? (
                    <AnaliticasNew currentUser={currentUser} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasListLoader,
                },
                {
                  path: ":tratamientoId/analiticas/:analiticasId",
                  element: isAuthenticated ? (
                    <AnaliticasPacienteItem
                      especialistaId={especialistaId}
                      userRole={userRole}
                    />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: AnaliticasPacienteItemLoader,
                },
                // Mejorate
                {
                  path: ":tratamientoId/mejorate",
                  id: "mejorate-intro",
                  element: isAuthenticated ? (
                    <MejorateIntro especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                  loader: MejorateIntroLoader,
                  children: [
                    {
                      path: "alcohol",
                      element: <MejorateAlcohol />,
                      loader: MejorateIntroLoader,
                    },
                    {
                      path: "cocaina",
                      element: <MejorateCocaina />,
                      loader: MejorateIntroLoader,
                    },
                    {
                      path: "benzodiazepina",
                      element: <MejorateBenzodiazepina />,
                      loader: MejorateIntroLoader,
                    },
                    {
                      path: "cannabis",
                      element: <MejorateCannabis />,
                      loader: MejorateIntroLoader,
                    },
                    {
                      path: "cuestionarios",
                      element: isAuthenticated ? (
                        <MejorateList especialistaId={especialistaId} userRole={userRole} />
                      ) : (
                        <Navigate
                          to={`/login?redirect_to=${encodeURIComponent(
                            window.location.pathname + window.location.search
                          )}`}
                        />
                      ),
                      loader: MejorateListLoader,
                    },
                  ],
                },
                {
                  path: "sueno",
                  element: isAuthenticated ? (
                    <Sueno especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
                {
                  path: "creditos",
                  element: isAuthenticated ? (
                    <Creditos especialistaId={especialistaId} userRole={userRole} />
                  ) : (
                    <Navigate
                      to={`/login?redirect_to=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}`}
                    />
                  ),
                },
              ],
            },
          ],
        },
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={router}>
        <TrackPageView />{" "}
        {/* Este componente solo se activará dentro del Router */}
      </RouterProvider>
    </>
  );
};

document.title = "App Tavad";

// Renderizar la aplicación
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
